export function CampaignDetail() {
  return <div>CampaignDetail</div>;
}
